import { Injectable } from "@angular/core";
import { inject } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "../../http/service/http.service";
import { IChangePassword } from "../type/user-profile.type";
import { environment } from "../../../../environments/environment";

@Injectable({ providedIn: "root" })
export class UserProfileApiService {
  private readonly httpService = inject(HttpService);

  changePassword(payload: IChangePassword): Observable<void> {
    return this.httpService.patch<void>(`${environment.apiBaseUrl}/api/account-management/password`, payload);
  }
}
